import { MuiOtpInput } from "mui-one-time-password-input";
import { useEffect, useState } from "react";

import {
  Button,
  FormControl,
  Grid,
  Stack,
  Typography,
  useTheme,
} from "@mui/material";
import axios from "axios";
import { LineWave } from "react-loader-spinner";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { baseURL } from "src/api/axios";
import LogoMail from "../../../assets/images/logos/business-and-finance.png";

const VerifyRegister = () => {
  const [otp, setOtp] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const [timer, setTimer] = useState(30);
  const [resendAllowed, setResendAllowed] = useState(false);
  const theme = useTheme();
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    console.log(location?.state);
  }, []);

  const countTime = () => {
    let time = 30;
    const counter = setInterval(() => {
      if (time <= 1) {
        setResendAllowed(true);
        time = 30;
        clearInterval(counter);
      }
      time -= 1;
      setTimer(time);
    }, 1000);
  };

  const handleChange = (newValue) => {
    setOtp(newValue);
  };
  useEffect(() => {
    if (!resendAllowed) {
      countTime();
    }
  }, [resendAllowed]);

  // useEffect(() => {
  //   axiosInstance.get('/users').then((response) => {
  //     if (response && response?.data?.isPhoneVerified) {
  //       window.location.href = '/dashboard';
  //     } else if (
  //       response &&
  //       response?.data?.isPhoneVerified &&
  //       (!response.data.gender || !response.data.dob)
  //     ) {
  //       window.location.href = '/auth/onboarding';
  //     }
  //   });
  // }, []);
  const resendEmail = async () => {
    setLoading(true);
    // let user = localStorage.getItem("store");
    let user = location?.state;
    // if (!location?.state || !location?.state?.number) {
    //   navigate("/auth/login");
    // }
    if (user) {
      // let cached = JSON.parse(user);
      axios
        .post(
          baseURL + "/auth/resendOTP",
          {
            phoneNumber: user?.number,
          },
          {
            headers: {
              Authorization: "Bearer " + user?.token?.token,
            },
          }
        )
        .then((r) => setTimeout(() => setLoading(false), 1500))
        .catch((e) => {
          if (e?.response?.status >= 400) {
            setError("Session expired , Please login again");
            setLoading(false);
          }
        });
    }
  };
  const submit = async () => {
    setError("");
    // if (!location?.state || !location?.state?.number) {
    //   navigate("/auth/login");
    // }
    if (otp.length < 3) {
      setError("Please Fill complete otp");
      return;
    }

    // if(!store) return

    try {
      let response = await axios.post(
        baseURL + "/auth/verify",
        {
          phoneNumber: location?.state?.number,
          otp,
        },
        {
          headers: {
            Authorization: `Bearer ${location?.state?.token?.token}`,
          },
        }
      );
      if (!response) {
        return;
      }
      let { data, status } = response;
      if (status === 401) {
        setError("Session has been expired, Please login again");
        return;
      }
      if (status < 202) {
        // window.history.pushState({}, "", "/verify");
        // // Replace the current entry with the /onboarding page
        // window.history.replaceState({}, "", "/auth/login");
        if (!location?.state?.userExists) {
          navigate("/auth/register/", {
            state: { number: location?.state?.number },
          });
        } else {
          new Promise((resolve) => {
            console.log({ data });
            localStorage.setItem("store", JSON.stringify({ user: data?.user }));
            localStorage.setItem("token", data?.tokens?.access?.token);
            resolve();
          }).then(() => {
            window.location.href = "/dashboard";
          });
        }
        // } else if (!data.verified) {
        //   setError("Invalid or Expired OTP, Please Try again");
      } else {
        setError(data?.message || data?.status);
      }
    } catch (e) {
      console.log(e);
      setError(
        e?.response?.data && Object.keys(e?.response?.data).includes("verified")
          ? "Invalid or Expired OTP, Please Try again"
          : "Something went wrong"
      );
    }
  };
  return (
    <>
      <Stack spacing={2}>
        {loading ? (
          <Stack direction={"row"} justifyContent={"center"}>
            <LineWave height={135} width={135} />
          </Stack>
        ) : (
          <>
            <Grid container spacing={2}>
              <Grid
                item
                xs={12}
                sx={{
                  display: "grid",
                }}
              >
                <Stack
                  direction={"row"}
                  justifyContent={"center"}
                  alignItems={"center"}
                  sx={{
                    width: "100px",
                    height: "100px",
                    borderRadius: "50%",
                    background: "#EFF1FA",
                    justifySelf: "center",
                    marginTop: "-2rem",
                    paddingLeft: 0,
                  }}
                >
                  <img
                    src={LogoMail}
                    alt={"Logo for otp earnpati"}
                    style={{ marginLeft: "20px" }}
                  />
                </Stack>
              </Grid>
              <Grid item xs={12}>
                <Typography variant="h5" mb={2} sx={{ textAlign: "center" }}>
                  Please Enter OTP for verification
                </Typography>
                <Typography
                  py={0.2}
                  sx={{ textAlign: "center", width: "100%", fontSize: "12px" }}
                >
                  {location?.state?.number
                    ? `We have sent an otp to: ${location?.state?.number}`
                    : "no number found"}
                </Typography>
              </Grid>
              <Grid item xs={12} sx={{ display: "grid", gap: "12px" }}>
                <FormControl
                  onKeyDown={(e) => {
                    if (e.key === "Enter") {
                      submit();
                    }
                  }}
                >
                  <MuiOtpInput
                    TextFieldsProps={{
                      type: "number",
                      inputProps: {
                        inputMode: "numeric",
                        pattern: "[0-9]*",
                        sx: {
                          "::-webkit-inner-spin-button": { display: "none" },
                          "::-webkit-outer-spin-button": { display: "none" },
                        },
                      },
                      size: "medium",
                    }}
                    value={otp}
                    onChange={handleChange}
                  />
                </FormControl>

                <Stack
                  alignItems={"end"}
                  width={"100%"}
                  sx={{
                    marginTop: "5rem",
                  }}
                >
                  {location.state.passwordExists ? (
                    <Typography
                      component={Link}
                      to="#"
                      fontWeight="500"
                      sx={{
                        textDecoration: "none",
                        color: "earnpati.main",
                      }}
                      onClick={(e) => {
                        e.preventDefault();
                        navigate("/auth/password_login", {
                          state: {
                            isRouted: true,
                          },
                        });
                      }}
                    >
                      login with password ?
                    </Typography>
                  ) : null}
                </Stack>

                <Button
                  sx={{
                    bgcolor: theme.palette.earnpati.main,
                    fontWeight: "bold",
                    marginTop: ".5rem",
                  }}
                  variant="contained"
                  onClick={submit}
                >
                  Verify OTP
                </Button>
              </Grid>

              <Grid item xs={12} sx={{ display: "grid" }}>
                <Typography
                  component={Link}
                  to="#"
                  fontWeight="500"
                  sx={{
                    textDecoration: "none",
                    color: resendAllowed ? theme.palette.earnpati.nav : "#aaa",
                    justifySelf: "center",
                  }}
                  onClick={(e) => {
                    e.preventDefault();
                    if (resendAllowed) {
                      setResendAllowed(false);
                      setTimer(30);
                      resendEmail();
                    }
                  }}
                >
                  Resend OTP{" "}
                  {!resendAllowed
                    ? `in 00 : ${timer >= 10 ? timer : `0${timer}`}`
                    : ""}
                </Typography>
                <Typography sx={{ color: "red" }}>{error}</Typography>
              </Grid>
            </Grid>
            {
              //     <Stack direction="row" justifyContent={"center"} alignContent={"center"}>
              //   <Typography sx={{ fontSize:"1rem"}}>
              //         Resend OTP in
              //   </Typography>
              //   </Stack>
            }
          </>
        )}
      </Stack>
    </>
  );
};

export default VerifyRegister;
